<template>
  <div class="flex flex-col lg:flex-row items-start">
    <div v-if="show_form" class="min-w-[40%] max-w-[40%] pt-7 sm:overflow-hidden">
      <div v-if="current_object_type?.type || !$store.state.settings.swot_objects_key_metrics" class="relative -space-y-px">
        <NewSuggestedListForm
          v-if="!is_update_list"
          :metrics-list="selected_metrics"
          group-type="growth_matrix"
          :object-type="current_object_type?.type"
          @cancel="
            () => {
              show_form = false
            }
          "
          @done="
            (new_list) => {
              growth_matrices_list.push(new_list)
              show_form = false
            }
          "
          @update="show_form = false" />
        <UpdateSuggestedList
          v-else
          :metrics-list="selected_metrics"
          :object-type="current_object_type?.type"
          :suggested-list="selected_list"
          @cancel="
            () => {
              is_update_list = false
              show_form = false
            }
          "
          @update="
            (new_list) => {
              $utils.replaceItem(growth_matrices_list, new_list)
              show_form = false
              is_update_list = false
            }
          "
          @done="
            () => {
              show_form = false
              getGrowthMatrices()
            }
          " />
      </div>
    </div>

    <!-- Suggested Lists -->

    <div class="w-full rounded-md px-5 mt-5">
      <div v-if="show_form" class="mb-10 mt-10">
        <div class="dark:text-white mb-2">
          {{ $t("Metrics Displayed") }}
        </div>
        <MultiSelectInputFlat
          :items="
            current_object_type?.type == 'company'
              ? [
                { name: 'Actual value', id: 's1' },
                { name: 'Forecasted value', id: 's2' }
              ].concat(
                $store.state.metrics.filter((t) => t.object_type == current_object_type?.type).filter((m) => m?.data_type === `Number`)
              )
              : $store.state.metrics.filter((t) => t.object_type == current_object_type?.type).filter((m) => m?.data_type === `Number`)
          "
          :value="selected_metrics"
          name="table_metrics"
          :is-draggable="true"
          label-attr="name"
          value-attr="id"
          :allow-null="false"
          :is-flat="true"
          :return-objects="false"
          :label="$t('Metrics list')"
          classes="w-full"
          input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light "
          :selection-text="null"
          :show-label="false"
          :limit="3"
          @update:currentItems="
            ($event) => {
              handleChange($event)
            }
          " />
      </div>
      <div v-if="current_object_type" class="flex">
        <div class="">
          <SelectInput
            v-if="!show_form"
            :allow-null="false"
            :disabled="growth_matrices_list.length ? true : false"
            :items="$store.state.object_types"
            :value="current_object_type"
            name="object_type"
            label-attr="label"
            :classes="`w-[21vw] mb-6`"
            :is-box-background="true"
            :label="$t('Object type')"
            :inline-label="true"
            :show-label="false"
            @update:currentItem="handleFilter($event)" />
        </div>
        <SelectInput
          v-if="!show_form"
          :value="
            $utils.getMetricById($store.state.settings.swot_objects_key_metrics[$utils.getObjectTypeByType(current_object_type?.type)?.id])
          "
          :items="$store.state.metrics.filter((t) => t.object_type == current_object_type?.type).filter((m) => m?.data_type === 'Number')"
          :allow-null="false"
          name="key_metric"
          :classes="'w-full mb-4 ml-2'"
          label-attr="name"
          :label="$t('Key Metric')"
          :show-label="true"
          input-classes="text-left"
          @update:currentItem="selectMetric" />
      </div>
      <div class="flex w-full">
        <div v-if="selected_metric" class="w-2/3">
          <h2 v-if="!show_form" class="text-base leading-5 font-medium text-light-black-text dark:text-dark-title-text pb-4">
            {{ $t("Quadrant Settings (Add up to 4)") }}
          </h2>
          <div v-if="!show_form" class="grid grid-cols-2 p-1">
            <div
              v-for="(list, i) in growth_matrices_list"
              :key="list.id"
              :class="[
                `dark:border-dark-divider-border rounded-none ${
                  !i
                    ? 'border rounded-tl-lg'
                    : i == 1
                      ? 'border-t border-b border-r rounded-tr-lg'
                      : i == 2
                        ? 'border-l border-b border-r rounded-bl-lg'
                        : i == 3
                          ? 'border-b border-r rounded-br-lg'
                          : ''
                } col-span-1 bg-white dark:bg-dark-box-background cursor-pointer hover:bg-gray-50 hover:dark:bg-gray-600 p-3 rounded-md relative shadow-md hover:shadow-lg`
              ]"
              @click="editList(list)">
              <div class="flex flex-col flex-1 m-2 mb-16">
                <p class="text-light-black-text dark:text-dark-title-text text-lg truncate group-hover:text-dark-body-text">
                  {{ list.name }}
                </p>
                <p v-if="list.description" class="text-common-grey text-sm group-hover:text-dark-body-text">
                  {{ list.description }}
                </p>
                <p v-else class="text-common-grey text-sm group-hover:text-dark-body-text">
                  ({{ $t("no description available") }})
                </p>
              </div>

              <div class="mt-auto w-full flex justify-between divide-gray-200 overflow-visible absolute bottom-2">
                <button class="cancel-btn w-1/4 m-2 mt-3 mr-0" @click.stop="deleteList(list)">{{ $t("Delete") }}</button>
                <button class="primary-btn w-1/4 m-2 mt-3 mr-0 relative right-6" @click="editList(list)">{{ $t("Edit") }}</button>
              </div>
            </div>

            <div
              v-for="(_, index) in Array(4 - growth_matrices_list.length)"
              :key="index"
              :class="[
                ` dark:border-dark-divider-border rounded-none ${
                  !(index + 1 + growth_matrices_list.length)
                    ? 'border rounded-tl-lg'
                    : index + growth_matrices_list.length == 1
                      ? 'border-t border-b border-r rounded-tr-lg'
                      : index + growth_matrices_list.length == 2
                        ? 'rounded-bl-lg border-l border-b border-r'
                        : index + growth_matrices_list.length == 3
                          ? 'border-b border-r rounded-br-lg'
                          : ''
                } items-center dark:text-white justify-center h-36 col-span-1 bg-white dark:bg-dark-box-background cursor-pointer hover:bg-gray-50 hover:dark:bg-gray-600 p-3 rounded-md relative shadow-md hover:shadow-lg`
              ]">
              <span class="flex items-center justify-center h-full" @click="handleCreateNew">
                <Plus class="w-7 h-7" />
                {{ $t("Add new to Quadrant") }} {{ index + 1 + growth_matrices_list.length }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="!show_form" class="w-1/3 border dark:border-dark-divider-border dark:text-common-grey rounded-lg p-4 ml-6">
          <div class="text-xl mb-2">
            {{ $t("Explanation") }}
          </div>
          <p class="font-light">
            {{
              $t(
                "Here you can create a Growth Matrix - a great bubble overview divided into up to four quadrants. Each Quadrant can have its own criteria and records will automatically be included based on those criteria. E.g. your Growth Matrix can have four expansion focused quadrants, “Price Increase Opps.“, “Cross-sale”, “Upsells” and “Upgrades”, each including customers that will be great opportunities for each."
              )
            }}
          </p>
          <p class="mt-2 font-light">
            {{
              $t(
                "Select a Key metric. The key metric you select will determine the size of the bubbles (customers) in the Growth Matrix. For example, if you select “ARR”, the higher the ARR of the customer, the bigger the bubble of that customer will be."
              )
            }}
          </p>
        </div>
      </div>
    </div>

    <Modal v-model:is-open="is_delete_list_modal_open" :default-success-msg="$t('Growth Matrix Deleted')">
      <template #form="{ close: closeModal, done: showIsDone, error: showError }">
        <h3 class="text-lg leading-6 font-medium text-gray-900 dark:text-white">
          {{ $t("Delete Growth Matrix") }} {{ selected_list.name }}
        </h3>
        <div class="mt-2 max-w-xl text-sm text-gray-500">
          <p>{{ $t("Once you delete a Growth Matrix, you can't restore it.") }}</p>
        </div>
        <div class="mt-5 text-center">
          <button
            type="button"
            class="inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm"
            @click="removeSelectedList(showIsDone, showError)">
            {{ $t("Delete") }}
          </button>
          <button
            type="button"
            class="inline-flex items-center dark:border-dark-divider-border dark:text-white justify-center px-4 py-2 ml-2 border font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm"
            @click="closeModal">
            {{ $t("Cancel") }}
          </button>
        </div>
      </template>
      <template #done="{ close: closeModal }">
        <div>
          <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
            <Check class="h-6 w-6 text-green-600" aria-hidden="true" />
          </div>
          <div class="mt-3 text-center sm:mt-5">
            <h3 class="text-lg leading-6 font-medium text-gray-900 dark:text-white">
              {{ $t("Growth Matrix deleted successfully") }}
            </h3>
          </div>
        </div>
        <div class="mt-5 sm:mt-6 text-center">
          <button type="button" class="cancel-btn" @click="closeModal">{{ $t("Done") }}</button>
        </div>
      </template>
      <template #error="{ close: closeModal }">
        <div class="flex flex-col items-center justify-center h-full px-4 text-center">
          <div class="flex justify-center">
            <CircleAlert class="w-20 h-20 m-10 text-red-400" aria-hidden="true" />
          </div>
          <h2 class="text-3xl font-extrabold text-gray-900 dark:text-dark-body-text">
            {{ $t("Error") }}
          </h2>
          <p class="mt-4 text-xl text-gray-500">
            {{ $t("Error deleting Growth Matrix, please try again!") }}
          </p>
          <button
            type="button"
            class="inline-flex items-center justify-center px-4 py-2 mt-10 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm group dark:text-dark-body-text dark:bg-dark-box-background dark:border-dark-divider-border hover:bg-gray-50 focus:outline-none"
            @click="closeModal">
            {{ $t("Close") }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import dataService from "@/services/data.service"
import Modal from "@/components/shared/Modal.vue"
import NewSuggestedListForm from "@/components/forms/NewSuggestedListForm.vue"
import UpdateSuggestedList from "@/components/forms/UpdateSuggestedList.vue"
import { Check, Plus, CircleAlert } from "lucide-vue-next"
import MultiSelectInputFlat from "@/components/shared/MultiSelectInputFlat.vue"
import SelectInput from "@/components/shared/SelectInput.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    CircleAlert,
    NewSuggestedListForm,
    UpdateSuggestedList,
    Modal,
    Check,
    MultiSelectInputFlat,
    SelectInput,
    Plus
  },
  data() {
    return {
      growth_matrices_list: [],
      is_update_list: false,
      selected_list: null,
      is_delete_list_modal_open: false,
      selected_metric: null,
      selected_metrics: [],
      show_form: false,
      current_object_type: null
    }
  },
  watch: {
    current_object_type() {
      this.selected_metric = this.$utils.getMetricById(
        this.$store.state.settings.swot_objects_key_metrics[this.$utils.getObjectTypeByType(this.current_object_type?.type)?.id]
      )
    }
  },
  created() {
    if (!this.$store.state.data.growth_object_type) {
      this.$store.dispatch("data/setGrowthObjectType", this.$utils.getObjectTypeByType("company"))
      this.current_object_type = this.$store.state.data.growth_object_type
    }
    this.getGrowthMatrices()
  },
  methods: {
    handleFilter(object_type) {
      this.selected_metrics = []
      this.current_object_type = object_type
      this.$store.dispatch("data/setGrowthObjectType", object_type)
    },
    handleCreateNew() {
      this.show_form = true
      this.selected_metrics = []
    },
    handleChange(e) {
      this.selected_metrics = e.map((m) => {
        if (m === "s1") {
          return { name: this.$t("Actual value"), id: "s1" }
        } else if (m === "s2") {
          return { name: this.$t("Forecasted value"), id: "s2" }
        } else {
          return this.$utils.getMetricById(m)
        }
      })
    },
    selectMetric(e) {
      this.selected_metric = e
      this.$store.dispatch("settings/setSwotObjectKeyMetic", {
        object_type: this.current_object_type.id,
        metric: this.selected_metric.id
      })
    },

    getGrowthMatrices() {
      this.growth_matrices_list = []
      this.$store.dispatch("ui/showLoading")
      dataService
        .getMatrixCompanies({
          type: "growth_matrix",
          include_rollup_metrics: false,
          include_records: false
        })
        .then((result) => {
          this.$store.dispatch("ui/hideLoading")
          result.data.data.forEach((list) => {
            this.growth_matrices_list.push(list)
          })

          if (this.$store.state.data.growth_object_type) {
            this.current_object_type = this.$store.state.data.growth_object_type
          } else {
            if (this.growth_matrices_list.length) {
              this.$store.dispatch("data/setGrowthObjectType", this.$utils.getObjectTypeByType(this.growth_matrices_list[0].type))
              this.current_object_type = this.$utils.getObjectTypeByType(this.growth_matrices_list[0].type)
            }
          }
        })
    },

    deleteList(list) {
      this.selected_list = list
      this.is_delete_list_modal_open = true
    },
    editList(list) {
      this.show_form = true
      this.selected_list = list
      this.selected_metrics = this.$store.state.data.solid_metrics_growth[list.id]
        ? this.$store.state.data.solid_metrics_growth[list.id].concat(list.displayed_metrics_stats.map((s) => this.$utils.getMetricById(s)))
        : [].concat(list.displayed_metrics_stats.map((s) => this.$utils.getMetricById(s)))
      this.is_update_list = true
    },
    removeSelectedList(showIsDone, showError) {
      dataService
        .deleteMatrix(this.selected_list.id)
        .then(() => {
          showIsDone()
          this.$emitter.emit(ALL_EMITTERS.REMOVE_GROWTH_LIST_FROM_GROWTH_MATRIX_COMPONENT, this.selected_list.id)
          this.$emitter.emit(ALL_EMITTERS.REMOVE_GROWTH_LIST_FROM_SWOT_VIEW, this.selected_list.id)

          this.growth_matrices_list.map((list, index) => {
            if (list.id === this.selected_list.id) {
              this.growth_matrices_list.splice(index, 1)
            }
          })
          this.selected_list = null
        })
        .catch(() => {
          showError()
        })
    }
  }
}
</script>
